(() => {
  const isEnglish = (document.documentElement.lang || '')
    .toLowerCase()
    .startsWith('en');

  const text = isEnglish
    ? {
        questions: [
          {
            eyebrow: 'Your lifestyle',
            title: 'What do you mainly expect from your next bra?',
            answers: [
              ['Everyday comfort', 'comfort'],
              ['Superior support', 'support'],
              ['Movement and exercise', 'sport'],
              ['To feel attractive', 'seduction'],
              ['For a particular outfit', 'occasion']
            ]
          },
          {
            eyebrow: 'Your preferences',
            title: 'What kind of fit do you prefer?',
            answers: [
              ['Full coverage and reassuring', 'full'],
              ['Natural and wireless', 'wireless'],
              ['Smooth under clothing', 'smooth'],
              ['Low-cut and feminine', 'plunge']
            ]
          }
        ],
        recommendations: {
          comfort: {
            path: 'sans-armatures',
            shapes: ['Spacer', 'Full-cup bra']
          },
          support: {
            path: 'emboitant',
            shapes: ['Full-cup bra', 'Side support']
          },
          sport: {
            path: 'sport',
            shapes: ['Sports bra', 'Moulded cup']
          },
          seduction: {
            path: 'seduction',
            shapes: ['Balconette', 'Plunge']
          },
          occasion: {
            path: 'sans-bretelles',
            shapes: ['Strapless', 'Plunge', 'Smooth cup']
          }
        },
        preferenceShapes: {
          full: 'Full-cup bra',
          wireless: 'Wireless',
          smooth: 'Spacer',
          plunge: 'Plunge'
        },
        question: 'QUESTION',
        of: 'OF',
        recommendationTitle: 'YOUR STYLE RECOMMENDATION',
        recommendationText:
          'These styles match what you are looking for and are an excellent starting point in your suggested size.',
        viewRecommendations: 'View my style recommendations',
        restart: 'Restart the questions',
        roundUnderIn:
          '<strong>Always round up to the next whole number.</strong> For example, 33.5 in becomes 34 in.',
        roundBustIn:
          '<strong>Always round up to the next whole number.</strong> For example, 39.5 in becomes 40 in.',
        roundUnderCm:
          '<strong>Always round up to the next whole number.</strong> For example, 84.5 cm becomes 85 cm.',
        roundBustCm:
          '<strong>Always round up to the next whole number.</strong> For example, 100.5 cm becomes 101 cm.',
        inchSuffix: 'in'
      }
    : {
        questions: [
          {
            eyebrow: 'Votre quotidien',
            title: 'Qu’attendez-vous surtout de votre prochain soutien-gorge?',
            answers: [
              ['Confort au quotidien', 'comfort'],
              ['Maintien supérieur', 'support'],
              ['Bouger et m’entraîner', 'sport'],
              ['Me sentir séduisante', 'seduction'],
              ['Une tenue particulière', 'occasion']
            ]
          },
          {
            eyebrow: 'Vos préférences',
            title: 'Quelle sensation préférez-vous?',
            answers: [
              ['Très enveloppante et rassurante', 'full'],
              ['Naturelle et sans armatures', 'wireless'],
              ['Lisse sous les vêtements', 'smooth'],
              ['Décolletée et féminine', 'plunge']
            ]
          }
        ],
        recommendations: {
          comfort: {
            path: 'sans-armatures',
            shapes: ['Spacer', 'Bonnet emboîtant']
          },
          support: {
            path: 'emboitant',
            shapes: ['Bonnet emboîtant', 'Maintien latéral']
          },
          sport: {
            path: 'sport',
            shapes: ['Soutien-gorge sport', 'Bonnet moulé']
          },
          seduction: {
            path: 'seduction',
            shapes: ['Balconnet', 'Plongeant']
          },
          occasion: {
            path: 'sans-bretelles',
            shapes: ['Sans bretelles', 'Plongeant', 'Bonnet lisse']
          }
        },
        preferenceShapes: {
          full: 'Bonnet emboîtant',
          wireless: 'Sans armatures',
          smooth: 'Spacer',
          plunge: 'Plongeant'
        },
        question: 'QUESTION',
        of: 'SUR',
        recommendationTitle: 'VOTRE RECOMMANDATION DE STYLE',
        recommendationText:
          'Ces formes correspondent à ce que vous recherchez et constituent un excellent point de départ dans votre taille suggérée.',
        viewRecommendations: 'Voir mes recommandations de styles',
        restart: 'Recommencer les questions',
        roundUnderIn:
          '<strong>Arrondissez toujours au nombre entier supérieur.</strong> Par exemple, 33,5 po devient 34 po.',
        roundBustIn:
          '<strong>Arrondissez toujours au nombre entier supérieur.</strong> Par exemple, 39,5 po devient 40 po.',
        roundUnderCm:
          '<strong>Arrondissez toujours au nombre entier supérieur.</strong> Par exemple, 84,5 cm devient 85 cm.',
        roundBustCm:
          '<strong>Arrondissez toujours au nombre entier supérieur.</strong> Par exemple, 100,5 cm devient 101 cm.',
        inchSuffix: 'po'
      };

  const cups = ['', 'A', 'B', 'C', 'D', 'DD', 'DDD', 'G', 'H', 'I', 'J'];

  function init(root) {
    if (root.dataset.bsfReady === 'true') return;

    root.dataset.bsfReady = 'true';

    const under = root.querySelector('[data-bsf-under]');
    const bust = root.querySelector('[data-bsf-bust]');
    const underLabel = root.querySelector('[data-bsf-under-label]');
    const bustLabel = root.querySelector('[data-bsf-bust-label]');
    const sizeLabel = root.querySelector('[data-bsf-size]');
    const styleLink = root.querySelector('[data-bsf-style-link]');
    const guide = root.querySelector('[data-bsf-guide]');
    const roundUnder = root.querySelector('[data-bsf-round-under]');
    const roundBust = root.querySelector('[data-bsf-round-bust]');

    if (
      !under ||
      !bust ||
      !underLabel ||
      !bustLabel ||
      !sizeLabel ||
      !styleLink ||
      !guide ||
      !roundUnder ||
      !roundBust
    ) {
      return;
    }

    const shopUrl = root.dataset.shopUrl || '/';
    const baseUrl = shopUrl.endsWith('/') ? shopUrl : `${shopUrl}/`;
    const guideState = { step: 0, answers: [] };

    let unit = 'in';
    let cupIndex = 4;

    function inches(value) {
      return unit === 'cm' ? Number(value) / 2.54 : Number(value);
    }

    function size() {
      const underMeasurement = Math.round(inches(under.value));
      const band =
        underMeasurement % 2 === 0
          ? underMeasurement + 2
          : underMeasurement + 1;

      return `${band}${cups[cupIndex]}`;
    }

    function displayedSize(value) {
      const match = value.match(/^(\d+)(DD|DDD)$/);

      if (!match) return value;

      return `${value} / ${match[1]}${match[2] === 'DD' ? 'E' : 'F'}`;
    }

    function productUrl(path, value) {
      const match = value.match(/^(\d+)(.+)$/);
      const params = new URLSearchParams();

      params.append('filter.v.availability', '1');

      if (match) {
        const equivalents = {
          DD: ['DD', 'E'],
          DDD: ['DDD', 'F']
        };

        (equivalents[match[2]] || [match[2]]).forEach((cup) => {
          params.append(
            'filter.v.option.taille',
            `${match[1]} ${cup}`
          );
        });
      }

      return `${baseUrl}collections/${path}?${params.toString()}`;
    }

    function update() {
      const suffix = unit === 'cm' ? 'cm' : text.inchSuffix;

      underLabel.textContent = `${under.value} ${suffix}`;
      bustLabel.textContent = `${bust.value} ${suffix}`;

      const value = size();

      sizeLabel.textContent = displayedSize(value);
      styleLink.href = productUrl('soutiens-gorge', value);
    }

    function updateUnitCopy() {
      if (unit === 'cm') {
        roundUnder.innerHTML = text.roundUnderCm;
        roundBust.innerHTML = text.roundBustCm;
      } else {
        roundUnder.innerHTML = text.roundUnderIn;
        roundBust.innerHTML = text.roundBustIn;
      }
    }

    function updateCup() {
      const difference = Math.round(
        inches(bust.value) - Math.round(inches(under.value))
      );

      cupIndex = Math.max(1, Math.min(10, difference));
      update();
    }

    function setUnit(next) {
      if (next === unit) return;

      const factor = next === 'cm' ? 2.54 : 1 / 2.54;
      const nextUnder = Math.round(Number(under.value) * factor);
      const nextBust = Math.round(Number(bust.value) * factor);

      unit = next;

      if (unit === 'cm') {
        under.min = 71;
        under.max = 112;
        bust.min = 74;
        bust.max = 137;
      } else {
        under.min = 28;
        under.max = 44;
        bust.min = 29;
        bust.max = 54;
      }

      under.value = nextUnder;
      bust.value = nextBust;

      root.querySelectorAll('[data-bsf-unit]').forEach((button) => {
        const active = button.dataset.bsfUnit === unit;

        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });

      updateUnitCopy();
      update();
    }

    function renderQuestion() {
      guide.hidden = false;

      const question = text.questions[guideState.step];

      guide.innerHTML = `
        <div class="bsf__guide-card">
          <div class="bsf__progress">
            <span style="width:${
              ((guideState.step + 1) / text.questions.length) * 100
            }%"></span>
          </div>

          <p class="bsf__eyebrow">
            ${text.question} ${guideState.step + 1}
            ${text.of} ${text.questions.length} · ${question.eyebrow}
          </p>

          <h2>${question.title}</h2>

          <div class="bsf__answers">
            ${question.answers
              .map(
                (answer) => `
                  <button
                    type="button"
                    data-bsf-answer="${answer[1]}"
                  >
                    ${answer[0]} <b>→</b>
                  </button>
                `
              )
              .join('')}
          </div>
        </div>
      `;

      guide.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }

    function renderGuideResult() {
      const activity = guideState.answers[0];
      const preference = guideState.answers[1];

      const recommendation =
        text.recommendations[activity] ||
        text.recommendations.comfort;

      const preferenceShape =
        text.preferenceShapes[preference];

      const shapes = [
        ...new Set(
          [...recommendation.shapes, preferenceShape].filter(Boolean)
        )
      ]
        .slice(0, 3)
        .join(' · ');

      guide.innerHTML = `
        <div class="bsf__guide-card bsf__guide-result">
          <p class="bsf__eyebrow">
            ${text.recommendationTitle}
          </p>

          <h2>${shapes}</h2>

          <p>${text.recommendationText}</p>

          <a
            class="bsf__button"
            href="${productUrl(recommendation.path, size())}"
          >
            ${text.viewRecommendations} <b>→</b>
          </a>

          <button
            type="button"
            class="bsf__restart"
            data-bsf-guide-start
          >
            ${text.restart}
          </button>
        </div>
      `;

      guide.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }

    under.addEventListener('input', updateCup);
    bust.addEventListener('input', updateCup);

    updateUnitCopy();
    update();

    root.addEventListener('click', (event) => {
      const unitButton = event.target.closest('[data-bsf-unit]');

      if (unitButton) {
        setUnit(unitButton.dataset.bsfUnit);
        return;
      }

      const start = event.target.closest('[data-bsf-guide-start]');

      if (start) {
        guideState.step = 0;
        guideState.answers = [];
        renderQuestion();
        return;
      }

      const answer = event.target.closest('[data-bsf-answer]');

      if (answer) {
        guideState.answers[guideState.step] =
          answer.dataset.bsfAnswer;

        guideState.step += 1;

        if (guideState.step < text.questions.length) {
          renderQuestion();
        } else {
          renderGuideResult();
        }
      }
    });
  }

  function boot(scope = document) {
    scope
      .querySelectorAll('[data-bra-size-finder]')
      .forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    boot(event.target);
  });
})();